import { navigate } from "raviger";
import { createDuplicateOrder } from "./createDuplicateOrder";

export async function createAndEditDuplicateOrder(id: string) {
    await createDuplicateOrder(id);
    navigate("/orders/new");
}